export default __webpack_public_path__ + "static/rovo-actions-dark-92e72be882dd16165e03db570d2a74a63759a55af442a47cbc299e5aec89a187.png";